var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgElo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1000 380.9",
    style: {
      enableBackground: "new 0 0 1000 380.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M156.1 83.4c11.6-3.8 23.7-5.7 35.9-5.7 54.9 0 100.7 38.2 111.1 88.9l77.7-15.5C363.1 64.9 285.3 0 192.1 0c-21.4 0-41.9 3.4-61.1 9.7l25.1 73.7z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#ffca05"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m65.8 333.3 53.2-58.8c-23.8-20.6-38.7-50.6-38.7-84.1s15-63.5 38.7-84L65.8 47.6C25.5 82.6 0 133.6 0 190.5c0 56.8 25.5 107.9 65.8 142.8",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#00a4df"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.2 214.3c-10.5 50.7-56.3 88.9-111.1 88.9-12.2 0-24.4-1.9-36-5.7l-25.2 73.8c19.2 6.3 39.8 9.7 61.2 9.7 93.2 0 170.9-64.8 188.8-151l-77.7-15.7z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#ee4123"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m601 253-2.3-1.4c-6.4 10.3-16.2 18.7-28.7 24.1-23.7 10.4-45.7 7.7-61.5-6.2l-1.4 2.2h-.1l-26.9 40.5c6.7 4.7 13.9 8.6 21.4 11.8 29.8 12.4 60.2 11.9 90.2-1.3 21.7-9.4 38.7-23.9 50.4-42.1L601 253zm-84.1-99.9c-25.1 10.8-38 34.4-35.3 62.1l106.2-45.9c-18.3-21.5-42-28.6-70.9-16.2zm-70.5 123.4c-3-5-5.7-10.2-8.1-15.6-12.3-28.6-12.8-58.1-2.5-86.5 11.4-31.1 33.1-55 61.2-67.1 35.3-15.3 74.4-12.3 108.2 7.9 21.5 12.4 36.7 31.5 48.3 58.6 1.5 3.5 2.8 7.2 4 10.3l-211.1 92.4zm285-228.9v225.1l34.9 14.2-19.8 46.4-38.5-16c-8.6-3.8-14.5-9.5-19-16-4.3-6.6-7.4-15.7-7.4-27.9V47.6h49.8zm90.3 167.8c0 18.4 7.8 35.9 21.6 48l-35.7 40.1c-25.2-22.4-39.5-54.5-39.4-88.1 0-33.7 14.4-65.7 39.6-88l35.7 40c-13.9 12.1-21.8 29.6-21.8 48zm63.5 63.9c30.7 0 56.3-21.8 62.3-50.9l52.5 10.8c-10.9 53.6-58.2 94-114.8 93.9-12.6 0-25.2-2.1-37.2-6.1l17.1-51c6.3 2.1 13 3.3 20.1 3.3zm.1-181.5c56.6 0 103.9 40.5 114.7 94.2l-52.5 10.7c-5.9-29.7-32-51.1-62.2-51.1-6.8 0-13.7 1.1-20.1 3.3l-16.9-51c11.9-4.1 24.4-6.1 37-6.1z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgElo);
export default __webpack_public_path__ + "static/media/elo.a4c63b6503ec081d36783111c845bbc3.svg";
export { ForwardRef as ReactComponent };